export const getPdbIdFromUrl = () => {
  return window.location.pathname.match(/[^\/]+$/)?.[0];
};
